import { TelegramSenderLayout } from "../TelegramSenderLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSBox, NSBoxEntity, NSBoxString, NSBoxTextArea, NSButtonBlue, NSColumn, NSPanel, NSRow, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { TelegramSenderRouterProps } from "../TelegramSenderRouterProps";
import { useRef } from "react";
import { ProviderRow } from "namirasoft-telegram-sender";
import { useParams } from "react-router-dom";
import { TelegramSenderRoutes } from "../TelegramSenderRoutes";
import { FilterItem, FilterItemOperator } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";

export interface ISendPageProps extends NSARouterMakerResult, TelegramSenderRouterProps
{ }

function SendPage(props: ISendPageProps)
{
	let NSBoxString_ChatID = useRef<NSBoxString>(null);
	let NSBoxString_MessageThreadID = useRef<NSBoxString>(null);
	let NSBoxTextarea_Message = useRef<NSBoxTextArea>(null);
	let NSBoxEntity_Provider = useRef<NSBoxEntity<ProviderRow>>(null);

	let { id } = useParams();

	let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

	return (
		<TelegramSenderLayout {...props}
			action={{
				title: "Send",
				description: "Enter the destination chat_id, message_thread_id and your message to send a message via the selected provider.",
				menus: {}
			}}
		>
			<NSPanel>
				<NSColumn style={{ width: NSBox.width.double }}>
					<NSRow>
						<NSBoxEntity<ProviderRow>
							ref={NSBoxEntity_Provider}
							title="Provider"
							required
							multiple={false}
							table={namirasoft.telegram_sender.tables.provider}
							getValue={item => item.id}
							getTitle={item => item.name}
							getSort={() => null}
							onLoaded={() =>
							{
								if (id)
									NSBoxEntity_Provider.current?.setValue(id);
							}}
							style={{ width: "100%" }}
							info={{ link: "https://namirasoft.com/telegram-sender/console-guide/send/#field-provider-id" }}
						/>
					</NSRow>
					<NSRow>
						<NSBoxString
							ref={NSBoxString_ChatID}
							title="Chat ID"
							required={false}
							info={{ link: "https://namirasoft.com/telegram-sender/console-guide/send/#field-chat-id" }}
						/>
						<NSBoxString
							ref={NSBoxString_MessageThreadID}
							title="Message Thread ID"
							required={false}
							info={{ link: "https://namirasoft.com/telegram-sender/console-guide/send/#field-message-thread-id" }}
						/>
					</NSRow>
					<NSRow>
						<NSBoxTextArea
							ref={NSBoxTextarea_Message}
							title="Message"
							required
							placeholder="Write your Message"
							style={{ width: "100%" }}
							info={{ link: "https://namirasoft.com/telegram-sender/console-guide/send/#field-message" }}
						/>
					</NSRow>
					<NSSpace size={NSSpaceSizeType.MINI} />
					<NSRow>
						<NSButtonBlue title="Apply" onClick={{
							action: (onFinished) =>
							{
								try
								{
									let provider_id = NSBoxEntity_Provider.current?.getValueOne();
									if (provider_id)
									{
										let chat_id = NSBoxString_ChatID.current?.getValue(false) ?? "";
										let message_thread_id = NSBoxString_MessageThreadID.current?.getValue(false) ?? ""
										let message = NSBoxTextarea_Message.current?.getValue() ?? ""
										props.servers.telegram_sender.telegram.Send({ provider_id, chat_id, message_thread_id, message }).then((res) =>
										{
											props.notifier.onSuccess("A message was sent successfully");

											let namirasoft = new NamirasoftMap(props.account.token_manager, props.notifier.onError);
											let filters = [new FilterItem(namirasoft.telegram_sender.tables.sent, namirasoft.telegram_sender.tables.sent.columns.id, false, FilterItemOperator.all.equals, res.id)];
											props.url.redirect(TelegramSenderRoutes.SentList, { filters: FilterItem.encode(filters) });
											onFinished();
										}).catch(onFinished);
									}
								} catch (error)
								{
									props.notifier.onError(error as Error);
								}
								onFinished();
							}
						}} />
					</NSRow>
				</NSColumn>
			</NSPanel>
		</TelegramSenderLayout>
	);
}

export default SendPage;